module.exports = __webpack_public_path__ + "static/media/m-sachic.e01a47b4.png";